/**
 * FR-015-032, `research.md` W-05: the scope names a collection's remembered view state is kept
 * under in local storage, one per workspace-wide collection and one per project. The seeded
 * defaults (`onboarding/defaults.ts`), the collections and the route fallbacks all name a scope
 * through these, and the fallbacks import nothing heavier to do it.
 */
export function workspaceScope(ws: string): string {
  return `ws:${ws}`;
}

export function projectScope(ws: string, project: string): string {
  return `ws:${ws}:project:${project}`;
}
